<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Promotions"></app-breadcrumb>

        <!-- count -->
        <div class="row">
            <div class="col-md-8 col-12">
                <p><span class="h3 font-weight-bold small-text">Promoted Items</span></p>
            </div>
            <div class="col-md-4 col-12 text-right">
                <button @click="viewGuide = true" class="btn btn-warning form-control">
                    <i class="fas fa-plus-circle"></i> New Promotion
                </button>
            </div>
        </div>
        <!-- promotions -->
        <div class="row my-3">
            <div class="col-12">
                <div class="table-responsive">
                    <table class="table table-striped mt-2">
                        <thead class="bg-silver">
                            <tr>
                                <th>S/N</th>
                                <th>Items</th>
                                <th>Plan</th>
                                <th>Status</th>
                                <th>Start</th>
                                <th>Stop</th>
                            </tr>
                        </thead>
                        <tbody v-if="myPromotions">
                            <tr v-for="(promotion, i) in myPromotions" :key="i">
                                <td>{{i+1}}.</td>
                                <td>
                                    <router-link class="d-inline-flex" :to="{ name: 'itemId', params: { id: promotion.id } }">
                                        <div class="mr-2">
                                            <img v-if="promotion.photo" :src="myProfilePhoto(promotion.photo)" class="item-message-photo img-thumbnail">
                                            <i v-else class="far fa-image fa-3x"></i>
                                        </div>
                                        <p class="m-0">
                                            <strong class="text-dark">{{promotion.title | capitalize}}</strong><br>
                                            <span class="text-muted text-truncate">
                                                {{promotion.description.substring(0, 20)}}...
                                            </span>
                                        </p>
                                    </router-link>
                                </td>
                                <td><strong>{{promotion.planName | capitalize}}</strong></td>
                                <td>
                                    <strong v-if="promotion.status" class="text-dark-green">Active</strong>
                                    <strong v-else class="text-danger">Ended</strong>
                                </td>
                                <td>{{promotion.starts | moment("MMM D YYYY")}}</td>
                                <td>{{promotion.stops | moment("MMM D YYYY")}}</td>
                            </tr>
                            <tr>
                                <td class="text-center" colspan="7">
                                    <i class="fas fa-long-arrow-alt-down"></i> <strong>load more promotions</strong> <i class="fas fa-long-arrow-alt-down"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- view a selected promotion -->
        <app-ghost-mode v-if="viewPromotion">
            <div class="row">
                <div class="col-12">
                    <div class="jumbotron screen-center p-4">
                        <h3 class="my-4">Views on this promotion</h3>
                        <ul class="list-group">
                            <li v-for="(x, i) in 5" :key="i" class="list-group-item">
                                <i class="far fa-user-circle"></i> Firstname Lastname
                            </li>
                        </ul>
                        <hr>
                        <button class="loadn btn btn-danger mr-2">End Promotion</button>
                        <button class="loadn btn btn-dark-green">Repeat Promotion</button>
                    </div>
                </div>
            </div>
        </app-ghost-mode>

        <!-- new promotion guide -->
        <app-ghost-mode v-if="viewGuide">
            <div class="row">
                <div class="col-12">
                    <div class="jumbotron screen-center">
                        <div class="negotiate-header bg-dark pt-3">
                            <h3 class="md-small-text text-center">New Promotion Guide</h3>
                        </div>
                        <div class="price-box">
                            <p class="mt-5">
                                Step 1: Locate the <router-link :to="{ name: 'items' }" class="text-dark-green font-weight-bold">Item</router-link> 
                                or <router-link :to="{ name: 'donations' }" class="text-dark-green font-weight-bold">Donation</router-link> 
                                you want to promote
                            </p>
                            <p>
                                Step 2: Click the <i class="fas fa-fire fa-2x text-warning"></i> Icon 
                                or <button class="btn btn-warning btn-sm"><i class="fas fa-fire"></i> Promote</button> 
                                on the item
                            </p>
                            <p>
                                Step 3: Select your <router-link :to="{ name: 'promotion-plans' }" class="text-dark-green font-weight-bold">Promotion Plan</router-link>, 
                                then click <button class="btn btn-dark-green btn-sm">Apply</button>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </app-ghost-mode>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { appendImgHostUrl } from '@/store/dry'
import { eventBus } from '@/main'

import Breadcrumb from '../shared/Breadcrumb.vue'
import GhostMode from '@/components/general/shared/GhostMode.vue'
import LayoutShop from '@/layouts/Shop.vue'

export default {
    name: "Promotions",
    data() {
        return {
            viewPromotion: false,
            viewGuide: false
        }
    },
    methods: {
        ...mapActions(['fetchPromotionRecords']),
        myProfilePhoto(path) {
            return appendImgHostUrl(path)
        },
    },
    computed: {
        ...mapGetters(['promotionRecords']),
        myPromotions() {
            if(this.promotionRecords && this.promotionRecords.length){
                return this.promotionRecords
            }
            return false
        },
    },
    components: {
        appGhostMode: GhostMode,
        appBreadcrumb: Breadcrumb
    },
    created() {
        this.fetchPromotionRecords().then(() => {}).catch((e) => {})
        eventBus.$on('hideGhostMode', (value) => {
            this.viewPromotion = value;
            this.viewGuide = value;
        }),
        this.$emit('update:layout', LayoutShop);
    }
}
</script>